import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Typography } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        background: "none",
        border: "none",
        color: "#023365",
        cursor: "pointer",
        fontSize: "16px",
        marginBottom: "40px",
    },
    card: {
        minHeight: theme.spacing(54),
    },
    info: {
        fontSize: "20px",
        fontStyle: "normal",
        fontWeight: 300,
        lineHeight: "170%",
        marginBottom: "35px",
        textAlign: "center",
    },
}); });
export var CheckoutKpayEmptyPayment = function () {
    var classes = useStyles();
    var _a = useCheckoutContext().handlers, setCheckoutSection = _a.setCheckoutSection, setEmailKpay = _a.setEmailKpay;
    var handler = function () {
        setEmailKpay("");
        setCheckoutSection(configCardSections.paymentMethods);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { className: classes.card, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" },
            React.createElement(Typography, { className: classes.info },
                React.createElement(T, { id: "emptyInfo" })),
            React.createElement(Button, { className: classes.button, onClick: handler },
                React.createElement(T, { id: "emptyInfoButton" })))));
};
